import {motion} from 'framer-motion'
import {useId} from 'react'
import styles from './RadioTabs.module.css'

export const RadioTab = ({
  onChange,
  defaultChecked,
  selected,
  value,
  primary,
  highlightId,
  children,
}) => {
  return (
    <label
      className={`${styles.radioTabBtn} ${
        primary && styles.radioTabBtnPrimary
      }`}
    >
      <input
        type="radio"
        name="tab"
        value={value}
        defaultChecked={defaultChecked}
        onChange={onChange}
      />
      {selected ? (
        <motion.div
          layoutId={highlightId}
          className={`${styles.activeIndicator} ${
            primary && styles.activeIndicatorPrimary
          }`}
        ></motion.div>
      ) : null}
      <div
        style={{
          position: 'relative',
          color: selected ? 'var(--clr-link)' : 'var(--clr-text)',
          transition: '0.3s ease',
        }}
      >
        {children}
      </div>
    </label>
  )
}
export const RadioTabs = ({
  options,
  customOptions,
  onChange,
  value,
  fullWidth = false,
  primary = false,
  classes = '',
}) => {
  const highlightId = useId()

  return (
    <div
      className={`${styles.radioTabs} ${
        fullWidth && styles.radioTabsFullWidth
      } ${primary && styles.radioTabsPrimary} ${classes}`}
    >
      {options.map((option, index) => (
        <RadioTab
          key={option.value}
          onChange={onChange}
          value={option.value}
          selected={value === option.value}
          primary={primary}
          highlightId={highlightId}
        >
          {option.label}
        </RadioTab>
      ))}

      {customOptions}
    </div>
  )
}
